import { Alert } from "./Alert.js";
import { AlertType } from "./AlertType.js";
import { ReplaySubject } from "@dooboostore/core";
class AlertService {
  constructor(alertFactory) {
    this.name = (/* @__PURE__ */ new Date()).toUTCString();
    this.subject = new ReplaySubject();
    this.alertFactory = alertFactory;
  }
  // @PostConstruct
  // postConstruct(
  // ) {
  //   this.alertFactory = alertFactory;
  // }
  // @PostConstruct
  // postConstruct(apiService: ApiService) {
  //   this.apiService = alertFactory;
  // }
  get observable() {
    return this.subject.asObservable();
  }
  publish(data) {
    this.subject.next(data);
  }
  create(factory, config) {
    return new class extends Alert {
      make() {
        return factory(this);
      }
    }(this, config);
  }
  createFromFactory(type, config) {
    return this.alertFactory?.create({ caller: this, type, config });
  }
  danger(config) {
    return this.createFromFactory(AlertType.DANGER, config);
  }
  progress(config) {
    config = config ?? {};
    return this.createFromFactory(AlertType.PROGRESS, config);
  }
  success(config) {
    return this.createFromFactory(AlertType.SUCCESS, config);
  }
  info(config) {
    return this.createFromFactory(AlertType.INFO, config);
  }
  error(config) {
    return this.createFromFactory(AlertType.ERROR, config);
  }
  warning(config) {
    return this.createFromFactory(AlertType.WARNING, config);
  }
}
export {
  AlertService
};
//# sourceMappingURL=AlertService.js.map
